export default __webpack_public_path__ + "static/vulnerability-3a49266406bf71c33554c4cf490a3097.png";